import React from 'react';
import LegalLayout, { COMPANY, H2, P, UL } from './LegalLayout';

const Refund: React.FC = () => (
  <LegalLayout
    slug="refund"
    title="Refund Policy"
    description="12and22 money-back guarantee and refund terms for hosting, VPS, email, and domains."
  >
    <P>
      This Refund Policy explains when you are entitled to a refund for Services purchased from{' '}
      {COMPANY.legalName} ({COMPANY.brand}). It forms part of our Terms of Service.
    </P>

    <H2>Shared hosting &amp; business email — 14-day money-back</H2>
    <P>
      New shared hosting and business email subscriptions include a <strong>14-day money-back
      guarantee</strong>. If you are not satisfied, request a refund within 14 days of your initial
      purchase for a full refund of the subscription fee. This applies to your first purchase of a plan
      only.
    </P>

    <H2>VPS — 7-day money-back</H2>
    <P>
      New VPS subscriptions include a <strong>7-day money-back guarantee</strong> from the date of
      initial purchase, reflecting the dedicated resources provisioned for you.
    </P>

    <H2>Non-refundable items</H2>
    <UL>
      <li><strong>Domain registrations and transfers</strong> — fees are paid to the registry at the
        time of purchase and cannot be refunded once submitted.</li>
      <li><strong>Renewals</strong> — the money-back guarantee applies to first purchases only, not to
        renewal charges. Cancel before your renewal date to avoid being charged.</li>
      <li>Fees for any period already used beyond the guarantee window.</li>
      <li>Accounts terminated for violations of the Acceptable Use Policy.</li>
    </UL>

    <H2>How to request a refund</H2>
    <P>
      Contact{' '}
      <a href={`mailto:${COMPANY.supportEmail}`} className="text-primary-navy underline">{COMPANY.supportEmail}</a>{' '}
      or open a support ticket from your dashboard, within the applicable window. Approved refunds are
      issued to your original payment method and typically appear within 5&ndash;10 business days,
      depending on your bank or card issuer.
    </P>

    <H2>Chargebacks</H2>
    <P>
      Please contact us before initiating a chargeback — we will work to resolve any billing issue.
      Accounts subject to a chargeback may be suspended pending resolution.
    </P>
  </LegalLayout>
);

export default Refund;
